import { Backdrop, Container, Fade, IconButton, Modal } from '@mui/material';
import React, { useState } from 'react';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { ModalContainer } from './modals/GlobalConfirmModal';

interface Props {
  children?: React.ReactNode;
  isOpen: boolean;
  onNext?: () => void;
  onPrev?: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  url: string;
}

const ImageViewer: React.FC<Props> = function ImageViewer({
  isOpen,
  setIsOpen,
  url,
  onNext,
  onPrev,
  children
}) {
  const [auxManualClose, setAuxManualClose] = useState<boolean>(isOpen);

  return (
    <Container sx={{ alignItems: 'center', width: 'auto' }}>
      <Modal
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
        onClose={() => {
          setIsOpen(false);
        }}
        open={auxManualClose}
        sx={{ maxHeight: '100vh' }}
      >
        <Fade in={auxManualClose}>
          <ModalContainer
            sx={{
              flexDirection: 'row',
              height: 'auto',
              maxHeight: 'inherit',
              maxWidth: '100vh',
              minWidth: 'auto',
              padding: '10px !important',
              width: '90vw'
            }}
          >
            <img
              alt=""
              loading="eager"
              src={url}
              style={{
                // height: 'auto',
                maxHeight: '90vh',
                maxWidth: '90vw',
                objectFit: 'contain',
                width: '-webkit-fill-available'
              }}
            />
            <CancelRoundedIcon
              key="task-details-img-view-cancel-icon"
              onClick={() => {
                setIsOpen(false);
              }}
              sx={{
                backgroundColor: 'rgb(255 255 255 / 67%)',
                borderRadius: '50%',
                cursor: 'pointer',
                fill: 'black',
                fontSize: '2.5rem',
                position: 'absolute',
                right: 0,
                top: 0
              }}
            />
            {onNext && (
              <>
                <IconButton
                  aria-label="Previous Image"
                  color="secondary"
                  onClick={onPrev}
                  size="large"
                  style={{
                    left: '10px',
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)'
                  }}
                >
                  <NavigateBeforeIcon />
                </IconButton>
                <IconButton
                  aria-label="Next Image"
                  color="secondary"
                  onClick={onNext}
                  size="large"
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)'
                  }}
                >
                  <NavigateNextIcon />
                </IconButton>
              </>
            )}
            {children}
          </ModalContainer>
        </Fade>
      </Modal>
    </Container>
  );
};

ImageViewer.defaultProps = {
  children: undefined,
  onNext: undefined,
  onPrev: undefined
};

export default ImageViewer;
